import styleInject from './../__node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "._YWVy2{flex-shrink:0}";
var styles = {"icon":"_YWVy2"};
var stylesheet="._YWVy2{flex-shrink:0}";
if(typeof process !== 'object' || !process.hasOwnProperty('env') || process.env.NODE_ENV !== 'test'){styleInject(css_248z);}

export { styles as default, stylesheet };
